import { Upload } from "lucide-react";
import { Tool } from "@/types/tool";

interface ToolCardImageProps {
  tool: Tool;
  favicon: string | null;
  uploading: boolean;
  isOwner: boolean;
  onImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ToolCardImage = ({ 
  tool, 
  favicon, 
  uploading, 
  isOwner, 
  onImageUpload 
}: ToolCardImageProps) => {
  return (
    <div className="relative flex-shrink-0">
      <div className="w-16 h-16 rounded-xl overflow-hidden shadow-md group-hover:shadow-lg transition-all duration-300">
        <img 
          src={favicon || tool.logo} 
          alt={tool.name} 
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.src = tool.logo;
          }}
        />
        {isOwner && (
          <label className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={onImageUpload}
              disabled={uploading}
            />
            <Upload className="w-5 h-5 text-white" />
          </label>
        )}
      </div>
    </div>
  );
};

export default ToolCardImage;